import React, { FC } from 'react'
import { BlockLayout, AddonData } from 'types'

import { AddonStyle } from './AddonStyle'
import AddonLayoutFactory from './AddonLayoutFactory'

/**
 * Addon component creates an add on with a specific title, features and price, given by the user.
 * AddonStyle component is used to style the add on
 */
const Addon: FC<{
  layout: BlockLayout
  data: AddonData
}> = ({ layout, data }) => (
  <AddonStyle>
    <AddonLayoutFactory element={layout} dataset={data} />
  </AddonStyle>
)

export default Addon
